export default "__VITE_ASSET__C4M32W5g__"